import { Form, Formik } from 'formik';

import styled from '@emotion/styled';

interface IFormComponent {
  initialValues: any;
  schema: any;
  onSubmit: any;
  children: any;
  className?: any;
  autoComplete?: string;
  enableReinitialize?: boolean;
}

export const FormComponent: React.FC<IFormComponent> = ({
  initialValues,
  schema,
  onSubmit,
  children,
  className,
  autoComplete = 'on',
  enableReinitialize = false,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
      enableReinitialize={enableReinitialize}
    >
      <StyledForm className={className} autoComplete={autoComplete}>
        {children}
      </StyledForm>
    </Formik>
  );
};

const StyledForm = styled(Form)`
  width: 100%;
  display: grid;
  gap: 24px;
  /* border: 2px solid red; */

  &.inline,
  &.smaller-inline {
    grid-template-columns: 517px auto;
    align-items: flex-end;

    & > button {
      margin-bottom: 19px;
      width: fit-content;
    }
  }

  &.smaller-inline {
    grid-template-columns: 460px auto;
  }

  &.small-gap {
    gap: 12px;
  }

  &.large-gap {
    gap: 32px;
  }
`;
